var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError404 = function SvgError404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 306,
    height: 187
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "error-404_svg__a",
    d: "M.044.444h23.851V25.09H.044z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M36.974 179.793c-34.956-11.67-15-102.162 6.402-146.345 21.401-44.182 88.19-36.424 110.007-22.745 21.816 13.68 64.519 46.874 99.811 58.848s55.568 32.832 52.306 71.392c-3.261 38.559-30.03 40.75-60.824 40.75-30.795 0-172.745 9.769-207.702-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADEE3",
    d: "M284.615 172.567c-1.797-3.42-9.098-6.17-12.366-6.792-17.439-3.323-35.705-2.859-53.37-2.803-19.24.06-37.597 3.135-56.676 4.557-9.922.738-20.41-.591-30.354-.934a4111 4111 0 0 1-49.12-1.995c-14.114-.657-28.763.817-41.213 8.584-1.414.883-2.844 1.949-3.488 3.534-4.044 9.95 46.359 8.7 52.926 8.871 33.124.86 66.27 1.305 99.4.41 24.63-.665 50.302-.625 74.73-4.094 5.402-.768 12.754-1.042 17.421-4.215 2.582-1.756 2.954-3.514 2.11-5.123"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D2E8F9",
    strokeWidth: 0.665,
    d: "M263.173 36.75q.646 0 1.33.025"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99A3AC",
    strokeDasharray: "2.670731735229492,2.670731735229492",
    strokeWidth: 0.665,
    d: "M267.168 36.96c8.59.871 19.078 4.494 17.852 11.91-1.955 11.82-54.597 7.461-67.17 7.583-25.286.247-50.838.343-75.63 5.861-6.028 1.341-14.663 4.303-14.006 11.98.23 2.681 1.812 5.108 3.827 6.923 7.24 6.527 17.327 7.152 26.692 8.297 14.164 1.734 81.538-.576 103.562 6.632 4.337 1.419 9.756 3.25 9.937 9.433.459 15.725-38.666 14.95-50.4 15.249-31.325.798-62.683.48-94.007-.136-25.313-.499-50.707-.94-75.98-2.57-9.42-.608-24.828-.79-32.014-7.85-4.017-3.946-4.544-11.123 1.808-14.788 4.477-2.584 17.61-1.454 22.665-1.888 15.286-1.313 10.663-10.567-1.725-11.753"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D2E8F9",
    strokeWidth: 0.665,
    d: "M41.247 81.749q-.653-.03-1.33-.03"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.205 25.154)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "error-404_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#error-404_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0FAFF",
    d: "m23.865 23.094-4.033-21.28C19.59.542 18.06.008 17.077.852L.63 14.978c-.983.845-.681 2.434.543 2.862l20.48 7.153c1.224.428 2.453-.628 2.212-1.899",
    mask: "url(#error-404_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#99A3AC",
    d: "m244.676 40.891 15.917 5.56-3.134-16.54zm16.286 7.033q-.174 0-.344-.058l-16.845-5.884a1.045 1.045 0 0 1-.337-1.777l13.528-11.62a1.047 1.047 0 0 1 1.71.597l3.318 17.505a1.043 1.043 0 0 1-1.03 1.237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99A3AC",
    d: "M253.648 40.779a.63.63 0 0 1-.396-.777l1.67-5.848a.991.991 0 1 1 1.87.652l-2.349 5.612a.63.63 0 0 1-.795.361m.123 1.594a.644.644 0 0 1-1.215-.424.644.644 0 0 1 1.215.424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0FAFF",
    d: "m38.636 74.56-13.26-6.588a1.15 1.15 0 0 0-1.661 1.098l.914 14.757a1.15 1.15 0 0 0 1.783.886l12.348-8.169a1.146 1.146 0 0 0-.124-1.983"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99A3AC",
    d: "m26.627 82.054 9.596-6.348-10.306-5.12zm10.55-5.94a.7.7 0 0 1-.173.163L26.85 82.995a.715.715 0 0 1-1.108-.55l-.751-12.138a.713.713 0 0 1 1.03-.682l10.908 5.419a.715.715 0 0 1 .25 1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99A3AC",
    d: "M30.267 77.137a.43.43 0 0 1-.587-.105l-2.498-3.32a.677.677 0 1 1 1.127-.745l2.09 3.59a.43.43 0 0 1-.132.58m.92.591a.44.44 0 0 1-.124.608.438.438 0 1 1-.485-.731.44.44 0 0 1 .609.123"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99A3AC",
    strokeWidth: 0.665,
    d: "M48.926 103.216a1.104 1.104 0 1 1-2.207-.002 1.104 1.104 0 0 1 2.207.002zM212.844 82.82a1.104 1.104 0 1 1-2.207-.001 1.104 1.104 0 0 1 2.207.002zm-86.969-30.886a1.104 1.104 0 1 1-2.207-.002 1.104 1.104 0 0 1 2.207.002zm-1.325 83.823a1.103 1.103 0 1 1-1.104-1.102c.61 0 1.104.493 1.104 1.102z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99A3AC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.665,
    d: "M149.182 70.856v2.493m1.249-1.246h-2.498"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D2E8F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.665,
    d: "M194.022 38.996v2.494m1.248-1.247h-2.498m70.622 66.017v2.495m1.249-1.247h-2.499"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M171.61 177.546s-4.651 1.98-4.647 2.97c.002.568 6.394-.245 6.779-.63.616-.614-.25-2.255-.25-2.255l-1.883-.085z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "m171.311 174.778.298 2.853s.154.462.805.513c.65.05 1.078-.513 1.078-.513l-.229-3.571"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M179.432 109.33c1.691 6.803 1.064 10.258-1.415 15.39-1.5 17.253-2.55 34.44-4.57 51.262l-2.136.121c-4.853-16.379-9.319-40.865-8.749-63.247m27.589 65.354s-4.65 1.98-4.646 2.97c.002.568 6.394-.245 6.779-.63.617-.614-.25-2.255-.25-2.255l-1.883-.086z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "m189.853 175.442.298 2.853s.154.462.805.513c.65.05 1.078-.513 1.078-.513l-.229-3.571"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M194.895 108.754c2.14 6.676 1.742 10.165-.39 15.45-.354 17.314-1.548 35.395-2.448 52.314h-2.196c-5.929-16.022-12.279-40.76-13.194-63.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#123056",
    strokeWidth: 0.6,
    d: "M193.836 111.52s2.48 5.79-1.712 13.924c-.483 7.675-.732 51.074-.732 51.074"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#123056",
    strokeWidth: 0.6,
    d: "M188.006 114.438c.793.718 1.804 1.158 2.841 1.397 1.039.24 2.11.288 3.175.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "M169.514 76.49c-7.396 12.845-15.357 24.477-20.077 38.523l-1.406-.746c.36-13.041 4.594-32.004 10.155-43.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADEE3",
    d: "M165.9 63.076s-2.29.64-4.978 2.427c-2.533 1.68-4.45 4.182-5.751 6.924-1.301 2.744-2.017 5.73-2.476 8.73 0 0 3.097 1.545 6.644 1.988 3.548.442 7.323 0 7.323 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADEE3",
    d: "M160.385 70.668c-.786 13.892-.186 28.182.167 41.696 0 0 4.853 1.289 16.645 1.289 11.748 0 19.44-3.575 19.44-3.575-2.276-13.887-4.087-30.928-9.66-42.36 0 0-6.29-6.772-12.496-7.05-1.248-.056-2.493.4-3.682.952-.875.406-4.9 1.388-4.9 1.388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9BA3AB",
    strokeWidth: 0.6,
    d: "M160.32 71.906c-.309 2.67-.309 10.914-.309 10.914"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99A3AC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.326,
    d: "M172.048 116.736c19.7-2.18 27.962 22.741 32.448 32.409 10.604 22.852 50.61 20.305 68.84 20.305 23.879 0 34.359 8.031 23.214 12.244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E85D5D",
    d: "M178.836 117.861c0 10.116-7.67 16.22-14.225 16.22h-10.753v-32.44h10.753c6.555 0 14.225 6.105 14.225 16.22",
    className: "fill-primary-color-hover"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA7268",
    d: "M173.296 117.861c0 9.884-5.864 17.896-13.097 17.896h-11.864V99.965h11.864c7.233 0 13.097 8.012 13.097 17.896",
    className: "fill-primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF5759",
    d: "M175.924 108.084a322 322 0 0 0-7.495 10.612c.344-.066.667-.235.917-.478 0 .269-.429.733-.05.907.38.173.781-.272 1.179-.15.371-.087.719-.553.99-.821a2 2 0 0 0-.166.626c2.617-1.015 4.959-3.451 6.995-5.412a16.4 16.4 0 0 0-2.37-5.284",
    className: "fill-primary-color-active"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E85D5D",
    d: "M162.278 117.861c0 9.884-5.863 17.896-13.096 17.896s-13.097-8.012-13.097-17.896 5.864-17.896 13.097-17.896 13.096 8.012 13.096 17.896",
    className: "fill-primary-color-hover"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF5759",
    d: "M150.276 124.203c0 1.469-1.005 2.66-2.245 2.66s-2.245-1.191-2.245-2.66c0-1.468 1.005-2.66 2.245-2.66s2.245 1.192 2.245 2.66m0-12.683c0 1.468-1.005 2.659-2.245 2.659s-2.245-1.19-2.245-2.66c0-1.468 1.005-2.659 2.245-2.659s2.245 1.19 2.245 2.66",
    className: "fill-primary-color-active"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "M190.56 80.92s.832 8.454-2.955 15.483c-3.239 6.012-9.672 13.793-14.87 18.08l-1.248-.304c1.809-6.928 7.519-19.23 7.874-23.844.355-4.613.27-9.957.355-12.526"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADEE3",
    d: "M174.481 60.668s6.97.476 11.015 3.887c5.773 4.868 6.628 14.398 6.628 16.611-1.745 1.882-5.56 1.979-8.339 1.979s-4.81-1.328-4.81-1.328l-.568-10.512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "M171.994 113.15c-.792.078-1.562.463-2.23.982-.61.477-1.36 1.274-1.282 1.638.083.384 1.083-.353 1.205-.204.122.148-1.714 2.914-1.368 3.122s1.907-2.3 1.907-2.3-1.516 2.677-.93 2.736c.491.05 1.836-2.484 1.836-2.484s-1.138 2.265-.748 2.35 1.445-2.17 1.445-2.17-.859 1.928-.53 1.96c.167.017 1.014-.942 1.369-2.103.347-1.144.755-2.135.44-3.027"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9BA3AB",
    strokeWidth: 0.6,
    d: "M179.266 72.409v9.577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M160.035 51.833q-.054.623-.05 1.248c.008.903.124 1.85.645 2.587.358.507.896.884 1.496 1.048.424.115.98.066 1.163-.332.064-.142.067-.303.066-.458a12.3 12.3 0 0 0-.883-4.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "M170.554 52.703c-.597-2.326-2.479-5.585-5.54-4.93-1.921.41-3.691 1.717-4.257 3.547-.674 2.185.42 4.726 1.732 6.51.484.658 1.057 1.284 1.805 1.67 1.772.914 4.163.165 5.366-1.358s1.367-3.597.894-5.439"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "m166.262 58.788 1 3.647-1.362.64s1.039 1.379 3.092 1.083c4.176-.6 5.489-3.49 5.489-3.49l-2.357-.245-2.61-4.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M172.591 50.165c-.292-1.599-1.434-2.956-2.825-3.8-2.473-1.498-5.99-1.618-8.191.446-1.253 1.175-3.508 5.342-.813 6.168.84.259 1.707-.253 2.439-.74l2.235-1.492c.267-.179.552-.362.873-.375.527-.022.964.435 1.152.925.189.491.203 1.03.325 1.542.087.361.246.733.56.934.314.2.809.141.968-.195.11-.234.033-.507.028-.766-.005-.258.14-.574.399-.562a.45.45 0 0 1 .25.108c.65.504.44 1.518.655 2.312.028.104-.19 1.711-.117 1.792 2.076-.48 2.272-5.15 2.062-6.297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "M169.52 52.454c-.047-.295.234-.567.53-.597.296-.032.585.117.814.308.39.325.672.802.68 1.308.006.398-.153.783-.37 1.115-.149.227-.34.444-.598.526-.33.104-.7-.047-.938-.298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M95.446 177.444s4.486.747 4.61 1.73c.07.564-6.287 1.236-6.719.904-.69-.53.156-2.519.156-2.519z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "m95.09 174.7.368 2.83s-.094.476-.733.611c-.638.134-1.135-.37-1.135-.37l-.528-3.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M78.322 110.204c-.802 6.963-.846 10.31 2.272 15.08 1.478 6.738 3.746 13.634 5.46 20.532-.738 8.236 4.436 21.357 7.22 30.728l2.011-.343c2.704-16.866 3.703-42.73 1.277-65.372"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#123056",
    strokeWidth: 0.6,
    d: "M79.63 119.638s7.718 24.455 7.718 25.783.21 5.893.553 8.853c.627 5.422 5.548 21.404 5.548 21.404"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A2F36",
    d: "m93.21 176.92-.311-1.222 2.594-.095.034 1.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M60.562 177.584s3.51 2.53 3.2 3.422c-.18.51-5.888-1.602-6.115-2.066-.364-.745 1.2-2.083 1.2-2.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "m61.422 175.092-.886 2.568s-.282.368-.884.213c-.601-.155-.812-.795-.812-.795l1.047-3.237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M63.246 108.754c-2.139 6.676-1.741 10.165.391 15.45.129 6.324.194 12.723.266 19.123-4.515 11.279-5.23 21.4-4.658 32.139l2.177.805s12.962-22.55 15.346-31.466c2.735-10.226 4.287-21.159 4.707-31.418"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#123056",
    strokeWidth: 0.6,
    d: "M63.781 110.204s-2.36 6.89.734 13.529c0 1.853 1.063 17.26.642 19.641-.201 1.142-2.32 6.589-3.735 11.89-1.566 5.865-1.896 19.696-1.896 19.696"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A2F36",
    d: "m58.84 175.464.346-1.452 2.785 1.294-.55 1.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF9467",
    d: "m99.503 57.196-1.747-1.488v-3.083c0-.478-.65-3.348-1.235-3.348s-.718-.717-1.012-.424c-.292.291.24 3.533 0 3.772-.24.24-.55-1.54-.771-1.318-.222.22-.24 1.525-.24 2.193 0 .667.534 1.897 1.065 2.426.53.528 2.875 3.058 2.875 3.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADEE3",
    d: "m98.628 56.208-1.46 1.659s5.767 7.62 7.594 10.17c-1.666-.583-4.058-2.042-5.44-2.947-2.713-1.776-5.433-2.717-7.314-2.717-3.995 0-1.904 13.142 2.73 15.066 8.79 1.319 18.643.484 20.151-2.6 2.237-4.57-10.648-15.338-16.26-18.63"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9BA3AB",
    strokeWidth: 0.6,
    d: "M104.762 68.037s1.1 3.065 3.055 4.066"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADEE3",
    d: "M71.824 65.85c-10.478 11.748-10.32 31.944-10.32 45.671 0 0 7.694 5.242 19.44 5.242 11.793 0 16.646-2.89 16.646-2.89.353-13.908-2.133-19.906.166-42.913 0 0-3.749-8.587-5.748-8.587s-9.819-.769-9.819-.769l-10.365 4.247z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9BA3AB",
    strokeWidth: 0.6,
    d: "M97.176 77.747s.238-4.018 1.216-4.994"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "M85.654 52.797c.39-2.37 2.081-5.756 5.188-5.374 1.95.241 3.461 1.586 4.553 3.16.936 1.35.583 2.642-.75 6.062-.424.699-1.34 1.947-2.051 2.397-1.685 1.067-4.133.53-5.465-.881s-1.784-3.489-1.475-5.364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M86.069 52.507c.447-.067.003-.356.2.05.126.26.164.335.418.42.248.082.253.31.46.463.323.241.598-.086.734-.363.253-.513.245-1.133.186-1.688-.047-.437-.193-1.128.235-1.432.352-.248 1.127.112 1.488.216.557.161 1.109.341 1.664.51 1.337.406 2.75.763 4.159.574 1.23-.165 2.5-.805 3.09-1.942.707-1.364-.705-3.148-2.144-3.15-.377 0-.735.153-1.104.228a.85.85 0 0 1-.413.007c-.313-.093-.452-.445-.63-.72-.533-.828-1.444-1.081-2.384-.98-1.065.118-1.975.628-2.99.905-.538.146-1.003.007-1.54.025a1.63 1.63 0 0 0-1.367.89c-.435-.453-1.405.66-1.647.953-1.062 1.29-1.397 3.149-1.426 4.779-.026 1.427.212 3.5 1.778 4.074.663.243 1.08.372 1.108-.234-.29-.629-.358-1.876-.417-2.4-.06-.523.093-1.148.581-1.353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "m91.17 58.458-.342 3.582 1.18.333s-.624 1.608-2.68 1.881c-4.183.557-7.139-2.65-7.139-2.65l1.397-.27 2.112-6.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "M86.767 52.482c.02-.297-.283-.542-.581-.548s-.572.169-.784.379c-1.17 1.162.3 3.996 1.455 2.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58636C",
    d: "M94.652 56.582c-.188.44-.93.615-1.336.66-1.967.216-3.6-1.053-5.484-1.285-.373-.046-.798-.077-1.076.175-.265.24-.29.638-.295.993-.009.44-.017.88.023 1.318.033.378.107.763.303 1.088.85 1.413 3.688 1.652 5.128 1.565.581-.036 1.184-.147 1.64-.49.648-.489.788-1.34 1.03-2.09.3-.924.067-1.934.067-1.934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "M93.255 58.126a.4.4 0 0 0-.209-.075c-.917 0-1.428-.22-2.145-.276a1 1 0 0 0-.364.018c-.256.077-.402.342-.455.596-.051.258.078.457.313.574.426.21.906.286 1.378.3.413.011.95.046 1.29-.231.195-.159.481-.7.192-.906"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99A3AC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.326,
    d: "M84.603 109.97c-22.89-1.194-36.217 10.598-45.683 32.075-12.283 27.872-29.452 30.099-37.185 29.945"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E85D5D",
    d: "M75.82 111.832c.844 10.08 8.995 15.526 15.528 14.983l10.715-.892-2.701-32.328-10.716.893c-6.533.543-13.668 7.263-12.825 17.344",
    className: "fill-primary-color-hover"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA7268",
    d: "M81.342 111.372c.823 9.85 7.334 17.348 14.542 16.748l11.823-.985-2.98-35.668-11.824.984c-7.208.6-12.383 9.07-11.56 18.92",
    className: "fill-primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E85D5D",
    d: "M92.321 110.458c.823 9.85 7.334 17.348 14.542 16.747s12.384-9.07 11.56-18.92c-.822-9.85-7.332-17.348-14.54-16.748-7.209.6-12.385 9.071-11.562 18.92",
    className: "fill-primary-color-hover"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF5759",
    d: "M104.81 115.782c.123 1.463 1.224 2.566 2.459 2.464 1.236-.103 2.138-1.373 2.016-2.837s-1.223-2.567-2.46-2.463c-1.234.102-2.138 1.372-2.015 2.836m-1.057-12.64c.124 1.463 1.224 2.567 2.46 2.464s2.138-1.372 2.016-2.837c-.123-1.463-1.223-2.567-2.46-2.463-1.235.102-2.138 1.372-2.016 2.836",
    className: "fill-primary-color-active"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99A3AC",
    d: "m106.362 104.799 16.712-1.392a1.86 1.86 0 0 0 1.69-2.014 1.86 1.86 0 0 0-2.001-1.707l-16.712 1.391c-1.279.107-1.034 3.834.311 3.722m1.056 12.64 16.712-1.392a1.86 1.86 0 0 0 1.69-2.014 1.86 1.86 0 0 0-2.001-1.708l-16.712 1.392c-1.278.106-1.034 3.833.311 3.722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "M66.242 80.92s-.83 8.454 2.956 15.483c3.239 6.012 9.672 13.793 14.87 18.08l1.248-.304c-1.809-6.928-7.519-19.23-7.874-23.844-.355-4.613-.27-9.957-.355-12.526"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADEE3",
    d: "M82.19 61.604s-7.346.422-11.57 3.608c-7.302 5.507-5.87 20.293-3.744 27.523s12.355 18.077 15.658 20.415c.54 0 2.132-.134 2.075-1.378-1.828-5.638-7.035-20.465-7.035-20.465l.822-20.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB288",
    d: "M84.81 113.15c.792.078 1.561.463 2.229.982.61.477 1.36 1.274 1.282 1.638-.083.384-1.083-.353-1.205-.204-.122.148 1.714 2.914 1.368 3.122s-1.907-2.3-1.907-2.3 1.516 2.677.93 2.736c-.49.05-1.836-2.484-1.836-2.484s1.138 2.265.748 2.35-1.444-2.17-1.444-2.17.858 1.928.529 1.96c-.167.017-1.013-.942-1.368-2.103-.348-1.144-.756-2.135-.442-3.027"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9BA3AB",
    strokeWidth: 0.6,
    d: "M79.632 97.198a2712 2712 0 0 0-2.059-5.891l1.543-16.789M65.2 78.596c-.042 4.553.507 10.163 1.677 14.14 1.023 3.479 3.923 7.797 7.025 11.6"
  }))));
};
export default SvgError404;